<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col">
                    <h1 class="text-white pt-3 px-3">สรุปข้อมูลยอดขาย</h1>
                    <p class="text-white pb-3 px-3">สรุปรายการยอดขายในแต่ละวันของพนักงานขาย</p>
                </div>
                <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
                    <h1 class="display-3 text-white" v-if="isAdmin()">
                        <small>วันหมดอายุ :</small>
                        {{dateExp}}
                    </h1>
                    <h1 class="display-3 text-white">
                        <small>ยอดรวมสุทธิทั้งหมด :</small>
                        {{totalNetPrice | numFormat('0,0.00')}}
                        <small>บาท</small>
                    </h1>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header bg-transparent">
                            <div class="row justify-content-between">
                                <div class="col-lg-12">
                                    <div class="row align-self-center">
                                        <div class="col-lg-5">
                                            <b-form-group id="input-group-1" label="ค้นหาวันที่ขายสินค้า (วันเริ่มต้น - วันสุดท้าย)" label-for="input-1" class="mb-0">
                                                <date-range-picker
                                                    class="w-100"
                                                    :opens="'center'"
                                                    @start-selection="logEvent('startSelection', $event)"
                                                    @finish-selection="logEvent('finishSelection', $event)"
                                                    :min-date="minDate"
                                                    :max-date="maxDate"
                                                    :singleDatePicker="false"
                                                    :appendToBody="true"
                                                    :ranges="false"
                                                    :closeOnEsc="false"
                                                    :autoApply="true"
                                                    :locale-data="{ format: 'dd-mm-yyyy' }"
                                                    v-model="filters">
                                                </date-range-picker>
                                            </b-form-group>
                                            <hr class="d-block d-md-none d-lg-none mb-0" />
                                        </div>
                                        <div class="col-lg-3">
                                            <b-form-group id="input-group-1" label="ตัวกรอง" label-for="input-1" class="mb-0">
                                                <select class="form-control" v-model="filterStatus">
                                                    <option :value="null">
                                                        {{'ดูสถานะทั้งหมด'}}
                                                    </option>
                                                    <option :value="status.key" v-for="status in dataStatus" :key="status.key">{{status.title}}</option>
                                                </select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-lg-3">
                                            <b-form-group id="input-group-2" label="ผู้ออกบิล" label-for="input-2" class="mb-0">
                                                <select class="form-control" v-model="filterUserCreate">
                                                    <option :value="null">
                                                        {{'ผู้ออกบิลทั้งหมด'}}
                                                    </option>
                                                    <option :value="user.name" v-for="(user , index) in dataUserCreate" :key="index">{{user.name}}</option>
                                                </select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-lg-1 d-flex align-items-end">
                                            <button class="btn btn-info btn-sm-res btn-block" v-on:click="getOrder(false)">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6">
                                    <b-form-group label="ตัวกรอง" label-for="input-1" class="mb-0 pb-2">
                                        <b-form-input v-model="filter" type="text" placeholder="ค้นหาข้อมูลในตาราง"></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-lg-8 col-md-6 d-flex justify-content-end">
                                    <b-form-group label="Export File" class="mb-0 pb-2">
                                        <div class="btn-group btn-sm-res btn-export" role="group" aria-label="Basic example">
                                            <ExportExcel 
                                                :columns="column" 
                                                :getData="getOrderExportExcel"
                                                name="สรุปข้อมูลยอดขาย " 
                                            >
                                            </ExportExcel>
                                            <b-button variant="info btn-sm-res" @click="$htmlToPaper('tablePrint')">print</b-button>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                        <div id="tablePrint" style="position: relative;">
                            <b-table 
                                show-empty empty-text="ไม่มีรายละเอียดข้อมูลยอดขาย" empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา" 
                                :items="order" 
                                :fields="fields" 
                                :filter="filter" 
                                responsive :busy="busy" 
                                class="scroll-bar-pop m-h-inherit table-min-500" outlined >
                                <div slot="table-busy" class="text-center">
                                    <BlockUI>
                                        <div class="loader"></div>
                                    </BlockUI>
                                </div>
                                <template slot="index" slot-scope="data">{{ getOverAllIndex( data.index ) }}</template>
                                <template slot="purchase_id" slot-scope="row">
                                    <b-badge :variant="statusOrder( row.item.purchase_id ).color">
                                        {{ statusOrder( row.item.purchase_id ).status }}
                                    </b-badge>
                                </template>
                                <template slot="receipt_no" slot-scope="row">
                                    <router-link tag="a" :to="`/cancelorders/${row.item.id}`">
                                        <u>{{ row.item.receipt_no }}</u>
                                    </router-link>
                                </template>
                                <template slot="num_all_parcel" slot-scope="row">{{ row.item.num_all_parcel }}</template>
                                <template slot="ship_price" slot-scope="row">{{ row.item.ship_price | numFormat('0,0.00') }}</template>
                                <template slot="ship_rate" slot-scope="row">{{ row.item.ship_rate | numFormat('0,0.00') }}</template>
                                <template slot="ship_service" slot-scope="row">{{ row.item.ship_service | numFormat('0,0.00') }}</template>
                                <template slot="insurance_price" slot-scope="row">{{ row.item.insurance_price | numFormat('0,0.00') }}</template>
                                <template slot="total_service_price" slot-scope="row">{{ row.item.total_service_price | numFormat('0,0.00') }}</template>
                                <template slot="total_service_price_exclude_vat" slot-scope="row">{{ row.item.total_service_price_exclude_vat | numFormat('0,0.00') }}</template>
                                <template slot="item_price" slot-scope="row">{{ row.item.item_price | numFormat('0,0.00') }}</template>
                                <template slot="total_other_no_vat" slot-scope="row">{{ row.item.total_other_no_vat | numFormat('0,0.00') }}</template>
                                <template slot="ship_fee" slot-scope="row">{{ row.item.ship_fee | numFormat('0,0.00') }}</template>
                                <template slot="vat" slot-scope="row">{{ row.item.vat | numFormat('0,0.00') }}</template>
                                <template slot="total" slot-scope="row">{{ row.item.total | numFormat('0,0.00') }}</template>
                                <template slot="discount" slot-scope="row">{{ row.item.discount | numFormat('0,0.00') }}</template>
                                <template slot="balance" slot-scope="row">{{ row.item.balance | numFormat('0,0.00') }}</template>
                                <template slot="manage" slot-scope="row">
                                    <div class="text-center">
                                        <base-dropdown :position="'right'">
                                            <template slot="title">
                                                <i class="fas fa-ellipsis-h"></i>
                                            </template>
                                            <router-link 
                                                class="dropdown-item" 
                                                :to="`/cancelorders/${row.item.id}`" >
                                                ดูรายละเอียดรายการ
                                            </router-link>
                                            <a 
                                                :class="row.item.purchase_id < 0 ? 'disabled text-muted': ''"
                                                class="dropdown-item"
                                                @click="printReceipt(row.item.id)" >
                                                พิมพ์ใบเสร็จ
                                            </a>
                                            <router-link
                                                class="dropdown-item"
                                                :class="row.item.purchase_id < 0 ? 'disabled text-muted': ''"
                                                :to="`/receipt/${row.item.id}`" target="_blank">
                                                ดูใบเสร็จ
                                            </router-link>
                                            <b-nav-item-dropdown dropright class="dropdown-item p-1 text-dark" :disabled="row.item.purchase_id < 0">
                                                <template #button-content>
                                                    <span>พิมพ์ใบปะหน้า</span>
                                                </template>
                                                <BtnLabel :labelId="row.item.id" />
                                            </b-nav-item-dropdown>
                                            <!-- <a 
                                                :class="row.item.purchase_id == -1 ? 'disabled': ''"
                                                class="dropdown-item" 
                                                href="/historycancel">
                                                ประวัติยกเลิกรายการ
                                            </a> -->
                                        </base-dropdown>
                                    </div>
                                </template>
                            </b-table>
                            <div class="mt-3">
                                <b-pagination
                                    :total-rows="pagination.totalItem"
                                    :current-page="pagination.currentPage"
                                    :per-page="pagination.perPage"
                                    :value="pagination.currentPage" 
                                    @input="changePage"
                                    align="right"
                                >
                                </b-pagination>
                            </div>
                            <!-- <div class="d-flex justify-content-center py-3" v-if="page.btnLoadmore">
                                <button class="btn btn-sm btn-info px-3 d-flex align-items-center" @click="getOrder(true)" :disabled="page.btnLoading">
                                    <div v-if="page.btnLoading" class="loader sm-loader mr-4">
                                    </div> โหลดเพิ่มเติม
                                </button>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import validatePop from "../plugins/validatePop.js"
import BtnLabel from '@/components/custom/printLabel/BtnLabel'
import moment from "moment";
import { statusOrder } from "@/plugins/statusOrder.js"
import { dateLimitRanges } from "@/plugins/datePicker.js"
import { getListUser } from "@/axios/user.js";
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'

const API_URL = process.env.VUE_APP_API
export default {
    name: "page-visits-table",
    components:{
        BtnLabel,
        ExportExcel
    },
    data() {
        return {
            pagination: {
                totalPage: 1,
                totalItem: 0,
                currentPage: 1,
                perPage: 20,
            },
            order: [],
            date: new Date(),
            busy: false,
            sortBy: 'created_at',
            sortDesc: true,
            message: 'Loading',
            vat: null,
            vatCourier: null,
            minDate: null,
            maxDate: moment().format("YYYY-MM-DD"),
            filter: null,
            dateExp: "",
            userLogin: "",
            filters: {
                startDate:"",
                endDate:""
            },
            date_excel: moment().format("DD-MM-YYYY"),
            modal: {
                idDel: "",
                msgBody: "success"
            },
            errorSys: {
                apiErrGetOrder: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #001",
                apiErrDelOrder: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #002",
                apiErrPrintOrder: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #003",

            },
            statusOrder: statusOrder,
            filterStatus: null,
            filterUserCreate: null,
            dataStatus:[
                { key: '1' , title: 'SUCCESS' }, 
                { key: '-3' , title: 'CANCEL' }
            ],
            dataUserCreate:[],
            totalNetPrice: 0
        }
    },
    filters: {
        dateFormat(date) {
            return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        }
    },
    mounted() {
        this.userLogin = JSON.parse(localStorage.getItem("user"));
        this.getDateNow(this.date)
        getListUser().then( res => {
            this.dataUserCreate = res
        });
        if(localStorage.getItem("fakeUser")) {
            localStorage.removeItem("fakeUser")
            window.location.reload()
        }
        this.getOrder()
    },
    methods: {
        logEvent( event , date ){
            const { minDate , maxDate } =  dateLimitRanges(event, date);
            this.minDate = minDate
            this.maxDate = maxDate
        },
        getOverAllIndex(index){
            return ( this.pagination.currentPage * 20 ) - 20 + index + 1
        },
        changePage(i){
            if (this.pagination.currentPage == i) return
            this.pagination.currentPage = i
            this.getOrder()
        },
        deleteOrder() {
            let id = this.modal.idDel
            this.$http
                .delete(API_URL + "/shop/order/" + id, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop(res)
                    if (!checkError.status) {
                        this.showErrorModal(checkError.msg)
                        return false
                    }
                    this.showSuccessModal("ลบข้อมูลสำเร็จ")
                    this.getOrder()
                })
                .catch(error => {
                    // eslint-disable-next-line
                    console.log('error in Dashboard->deleteOrder: ' + error)
                    this.showErrorModal(this.errorSys.apiErrDelOrder)
                });
        },
        getOrder(loadMore = false) {
            this.busy = !loadMore
            let dateStart = moment(this.filters.startDate).format("YYYY-MM-DD")
            let dateEnd = moment(this.filters.endDate).format("YYYY-MM-DD")
            this.$bvModal.hide()
            this.$http
                .get(
                    API_URL + "/orders?date_start=" + dateStart + "&date_end=" + dateEnd, {
                        headers: {
                            Token: localStorage.getItem("access_token")
                        },
                        params: {
                            page: this.pagination.currentPage,
                            user_name: this.filterUserCreate,
                            purchase_id: this.filterStatus,
                        }
                    }
                )
                .then(res => {
                    let checkError = validatePop(res)
                    if (!checkError.status) {
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout")
                        }
                        this.busy = false
                        this.showErrorModal(checkError.msg)
                        return false
                    }

                    let result = res.data.data;
                    this.order = res.data.data[0]
                    this.pagination.totalPage = result.total_page
                    this.pagination.totalItem = result.total_item
                    this.pagination.perPage = result.per_page
                    this.pagination.currentPage = result.page
                    this.dateExp = this.$options.filters.dateFormat(result.expired_date)
                    this.totalNetPrice = result.total_net_price
                    // this.dataUserCreate = [...new Set( this.order.map(item => item.user_create).filter((value, index, self) => self.indexOf(value) === index) )];
                    this.busy = false
                })
                .catch(error => {
                    this.busy = false
                    this.showErrorModal(this.errorSys.apiErrGetOrder)
                })
        },
        async getOrderExportExcel() {
            return new Promise( resolve => {
                let ExcelTask = []
                let page = 1;
                let dateStart = moment(this.filters.startDate).format("YYYY-MM-DD")
                let dateEnd = moment(this.filters.endDate).format("YYYY-MM-DD")

                for( let i = 0 ; i < this.pagination.totalPage; i++ ){
                    ExcelTask.push( this.$http
                        .get(
                            this.$API_URL + "/orders?date_start=" + dateStart + "&date_end=" + dateEnd,{
                                headers: {
                                    Token: localStorage.getItem("access_token")
                                },
                                params: {
                                    user_name: this.filterUserCreate,
                                    purchase_id: this.filterStatus,
                                    page: page++
                                }
                            }
                        )
                    ) 
                }
                Promise.all(ExcelTask).then( (resData) => {
                    let dataExcel = [];
                    resData.forEach( data => {
                        dataExcel.push(...data.data.data[0])

                    })
                    resolve(dataExcel)
                })
            })
        },
        printReceipt(id) {
            this.$http.get(API_URL + `/order/${ id }/receipt`, {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                }).then(res => {
                    let checkError = validatePop(res)
                    if (!checkError.status) {
                        this.showErrorModal(checkError.msg)
                        return false
                    }
                    const win = window.open('')
                    let html = res.data.data
                    win.document.write(html);
                    setTimeout(() => {
                        win.document.close();
                        win.focus();
                        win.print();
                        win.close();
                    }, 100);
                })
                .catch(error => {
                    this.showErrorModal(this.errorSys.apiErrPrintOrder)
                })
        },
        sendLabel(id) {
            this.$router.push(`/label/${id}/${this.sizeLabel.code}`);
        },
        isAdmin() {
            return this.userLogin.role === "admin";
        },
        getDateNow(myDate) {
            var month = ("0" + (myDate.getMonth() + 1)).slice(-2);
            var date = ("0" + myDate.getDate()).slice(-2);
            var year = myDate.getFullYear();
            var formattedDate = year + "-" + month + "-" + date;
            this.filters.startDate = formattedDate;
            this.filters.endDate = formattedDate;
        },
        showComfirmModal() {
            this.$bvModal
                .msgBoxConfirm(`คุณต้องการจะลบรายการ `, {
                    title: "กรุณายืนยัน",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "danger",
                    okTitle: "ยืนยัน",
                    cancelTitle: "ยกเลิก",
                    contentClass: "modal-confirm",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        this.deleteOrder();
                    }
                });
        },
        showErrorModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "ERROR",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "ลองอีกครั้ง",
                contentClass: "modal-errors",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
        showSuccessModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
                title: "SUCCESS",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: "ตกลง",
                contentClass: "modal-success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true
            });
        },
        setTypeUrlLabel( id , size , dropoff ){
            let url = `/label/${id}/${size}`
            if( dropoff ){
                url = url+'/dropoffShippop'
            }
            return url
        }
    },
    computed: {
        fields(){
            let fields = [
                { key: "index", label: "#", sortable: true },
                { key: "created_at", label: "วันที่สร้างรายการ", sortable: true },
                { key: "receipt_no", label: "รหัสรายการ", sortable: true },
                { key: "purchase_id", label: "สถานะ", sortable: true, class:"text-cneter" },
                { key: "num_all_parcel", label: "จำนวนพัสดุ", sortable: true },
                ...(this.vat && !this.vatCourier) ? [{ key: "ship_rate", label: "ค่าขนส่ง (รวมค่าพื้นที่ห่างไกล)", sortable: true }] 
                            : [{ key: "ship_price", label: "ค่าขนส่ง", sortable: true }] ,
                ...(this.vat && !this.vatCourier) ? [{ key: "ship_service", label: "ค่าบริการ", sortable: true }] : [],
                { key: "item_price", label: "ค่าสินค้าและบริการ", sortable: true },
                ...(this.vat)?[{ key: "total_other_no_vat", label: "สินค้า/บริการ(รับแทน)", sortable: true }]: [],
                { key: "ship_fee", label: "ค่าบริการอื่นๆ", sortable: true },
                { key: "insurance_price", label: "ค่าประกันสินค้า", sortable: true },
                { key: "total", label: "ยอดรวม" },
                { key: "discount", label: "ส่วนลด" },
                ...(this.vat && !this.vatCourier) ? [{ key: "total_service_price", label: "ค่าสินค้าและบริการ (ลดส่วนลด)" }] : [],
                ...(this.vat) ? [
                    { key: "total_service_price_exclude_vat", label: "ค่าสินค้าและบริการ (ก่อน Vat)" },
                    { key: "vat", label: "ภาษีมูลค่าเพิ่ม" }
                ]: [],
                { key: "balance", label: "ยอดสุทธิ" },
                { key: "sender_name", label: "ผู้ส่ง", sortable: true },
                { key: "user_create", label: "ผู้ออกบิล", sortable: true },
                { key: "manage", label: "การจัดการ" }
            ];

            return fields;
        },
        column(){
            let column = [
                {
                    label: "วันที่สร้างรายการ",
                    field: "created_at",
                    dataFormat: value => {
                        return `${this.$options.filters.dateFormat(value)}`;
                    },
                },
                {
                    label: "รหัสรายการ",
                    field: "receipt_no",
                },
                {
                    label: "จำนวนพัสดุ",
                    field: "num_all_parcel",
                },
                ...(this.vat && !this.vatCourier) 
                ? [{ label: "ค่าขนส่ง (รวมค่าพื้นที่ห่างไกล)", field: "ship_price",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    } 
                }] 
                : [{ label: "ค่าขนส่ง", field: "ship_price",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    }
                }],
                ...(this.vat && !this.vatCourier) 
                ? [{ label: "ค่าบริการ", field: "ship_service", 
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    } 
                }] 
                : [],
                {
                    label: "ค่าสินค้า",
                    field: "item_price",
                },
                {
                    label: "สินค้า/บริการ(รับแทน)",
                    field: "total_other_no_vat",
                },
                {
                    label: "ค่าบริการอื่นๆ",
                    field: "ship_fee",
                },
                ...(this.vat) ? [{ label: "ค่าประกันสินค้า", field: "insurance_price",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    } 
                }]
                : [],
                {
                    label: "ยอดรวม",
                    field: "total",
                },
                {
                    label: "ส่วนลด",
                    field: "discount",
                },
                ...(this.vat && !this.vatCourier) 
                ? [{ label: "ค่าสินค้าและบริการ (ลดส่วนลด)", field: "total_service_price",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    } 
                }] 
                : [],
                ...(this.vat) 
                ? [
                    { label: "ค่าสินค้าและบริการ (ก่อน Vat)", field: "total_service_price_exclude_vat",
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        } 
                    },
                    { label: "ภาษีมูลค่าเพิ่ม", field: "vat",
                        dataFormat: value => {
                            return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                        } 
                    }
                ]: [],
                {
                    label: "ยอดสุทธิ",
                    field: "balance",
                    dataFormat: value => {
                        return `${this.$options.filters.numFormat(value,'0,0.00')}`;
                    }
                },
                {
                    label: "ผู้ส่ง",
                    field: "sender_name",
                },
                {
                    label: "ผู้ออกบิล",
                    field: "user_create",
                },
            ]

            return column;
        }
    }
};
</script>